import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../src/components/Student/StuStyles/StudentProfile.css";
import profilepic from  "../assets/board3.jpg";
import idimg from  "../assets/img1.png";
import { TiArrowBack } from "react-icons/ti";
import { useNavigate} from "react-router-dom";

const CandidateProfile = () => {
  const navigate = useNavigate();
  return (
    <div className="container student-profile-container mt-5 mb-0">

      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4 className="fw-bold mt-3">EMPLOYEE REGISTRATION</h4>
        
      </div>
      {/* Personal Details */}
      <div className="card p-3 mb-4">
        <h5 className="section-title text-center">Personal Details</h5>
            
         <button className="jobback" style={{width:"80px"}} onClick={() => navigate(-1)} > <TiArrowBack />Back</button>
        <div className="row g-3 mt-2">
          <div className="col-md-4">
            <label className="form-label">Profile Pic</label>
            <img
              src={profilepic}
              alt="profile"
              className="profile-pic"
            />
          </div>

          <div className="col-md-4">
            <label className="form-label">Full Name</label>
            <input className="form-control" value="Manikanta" readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label">Email</label>
            <input className="form-control" value="mani123@gmail.com" readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label">Date Of Birth</label>
            <input className="form-control" value="16/08/2004" readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label">Gender</label>
            <input className="form-control" value="Male" readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label">State</label>
            <input className="form-control" value="Andhra Pradesh" readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label">District</label>
            <input className="form-control" value="Kakinada" readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label">Pincode</label>
            <input className="form-control" value="500437" readOnly />
          </div>
          <div className="col-md-4">
            <label className="form-label">Blood Group</label>
            <input className="form-control" value="o+" readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label">Mobile Number</label>
            <input className="form-control" value="7816058640" readOnly />
          </div>
        </div>
      </div>

      {/* Student Details - 1 */}
      <div className="card p-3 mb-4">
        <h5 className="section-title text-center">Company Experience-1</h5>

        <div className="row g-3 mt-2">
          <div className="col-md-4">
            <label className="form-label">Organization Name</label>
            <input className="form-control" value="YSK INFOTECH PVT.LTD" readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label">Designation</label>
            <input className="form-control" value="UI/UX Designer" readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label">Department</label>
            <input className="form-control" value="Design Department" readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label">Industry</label>
            <input className="form-control" value="IT" readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label">Company website URL</label>
            <input className="form-control" value="yskinfotech.com" readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label">Working Location</label>
            <input className="form-control" value="Hyderabad" readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label">Employee ID</label>
            <input className="form-control" value="NHRC-E-01" readOnly />
          </div>
           <div className="col-md-4">
            <label className="form-label">Experience</label>
            <input className="form-control" value="02" readOnly />
          </div>
          
           <div className="col-md-4">
            <label className="form-label">Official Email</label>
            <input className="form-control" value="yskinfotechpvtltd@gmail.com" readOnly />
          </div>

           <div className="col-md-4">
            <label className="form-label">Company Strength</label>
            <input className="form-control" value="100" readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label">ID Card Proof</label>
              <img
              src={idimg}
              alt="ID"
              className="id-proof-img"
            />
          </div>

          <div className="col-md-4">
            <label className="form-label">Referral ID</label>
            <input className="form-control" value="Social media" readOnly />
          </div>
        </div>
      </div>

      {/* Student Details - 2 */}
      <div className="card p-3 mb-4">
        <h5 className="section-title text-center">Company Experience -2</h5>

        <div className="row g-3 mt-2">
          <div className="col-md-4">
            <label className="form-label">Organization Name</label>
            <input className="form-control" readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label">Designation</label>
            <input className="form-control"  readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label">Department</label>
            <input className="form-control" readOnly />
          </div>

           <div className="col-md-4">
            <label className="form-label">Industryt</label>
            <input className="form-control" readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label">Company website URL</label>
            <input className="form-control" readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label">Working Location</label>
            <input className="form-control" readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label">Employee ID</label>
            <input className="form-control" readOnly />
          </div>
           <div className="col-md-4">
            <label className="form-label">Experience</label>
            <input className="form-control"  readOnly />
          </div>
          
           <div className="col-md-4">
            <label className="form-label">Official Email</label>
            <input className="form-control"  readOnly />
          </div>

           <div className="col-md-4">
            <label className="form-label">Company Strength</label>
            <input className="form-control" readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label">ID Card Proof</label>
            <img
              src={idimg}
              alt="ID"
              className="id-proof-img"
            />
          </div>

          <div className="col-md-4">
            <label className="form-label">Referral ID</label>
            <input className="form-control"  readOnly />
          </div>
          </div>

        <div className="text-end mt-3">
          <button className="btn btn-primary">Add Another Company Details</button>
        </div>
      </div>
    </div>
  );
};

export default CandidateProfile;
